module.exports = __webpack_public_path__ + "media/vb.2afeb980.mp4";